import * as React from 'react';
import { Str } from '../localization/translationKeys';
import { css, SerializedStyles } from '@emotion/core';
import Msg from '../localization/Msg';


const styles = {
  root: css`
    display: flex;
    flex-direction: column;
  `,
  value:         css`
    font-size: 30px;
    font-weight: bold;
    text-align: center;
  `,
  label:          css`
    font-size: 11px;
    text-align: center;
  `,
};


type Props = {
  value: string | number;
  label: Str;
  defaultLabel?: string | number;
  valueStyle?: SerializedStyles;
  labelStyle?: SerializedStyles;
  className?: string;
};


/**
 * Metric: a component that renders a value with a label underneath.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const Metric: React.FC<Props> = props => (
  <div css={styles.root} className={props.className}>
    <span css={[styles.value, props.valueStyle]}>{props.value}</span>
    <Msg
      str={props.label}
      defaultMsg={props.defaultLabel}
      css={[styles.label, props.labelStyle]}
    />
    {props.children}
  </div>
);

export default Metric;
